module.exports = __webpack_public_path__ + "assets/img/pay.71b1216a.jpg";